<template>
  <div :class="$style['exchange-record-header']">
      <wt-box direction="row">
          <div>已兑换次数：<span :class="$style['exchange-record-number']">{{statisticalNum.usageCount}}</span></div>
          <div>累计已使用积分：<span :class="$style['exchange-record-number']">{{statisticalNum.consumeCount}}</span></div>
          <div>当前可用积分：<span :class="$style['exchange-record-number']">{{statisticalNum.availableAmount}}</span></div>
      </wt-box>
      <pt-page-title :isSearch="true" @search="search" @emptySearch="emptySearch" :searchKey="keyword" :isParams="true">
    </pt-page-title>
     <pt-sub-title title="兑换记录"></pt-sub-title>
    <wt-paged-table :on-request-data="getTableData" :total-size="totalNumber" :page-size="pageSize" ref="table">
        <wt-table :list="tableData" :labels="tableLabels">
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="text" @click="recordDetail(scope.row)">详情</el-button>
                </template>
            </el-table-column>
        </wt-table>
    </wt-paged-table>
  </div>
</template>
<script>
export default {
  props: {
    pageSize: {
      type: Number,
      default: 10
    },
    userLogin: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  components: {
  },
  data () {
    return {
      tableData: [],
      totalNumber: 0,
      keyword: '',
      statisticalNum: {}
    }
  },
  computed: {
  },
  watch: {
    keyword: {
      handler (val) {
        this.getTableData(0)
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    search (val) {
      this.keyword = val
    },
    emptySearch (val) {
      this.keyword = null
    },
    recordDetail (row) {
      this.$router.push('/integral-exchange-detail/' + row.id + '/detail')
    },
    getTableData (page, next) {
      let data = {
        // example: {
        userId: this.id,
        // },
        pageable: {
          page: page,
          size: this.pageSize,
          sort: 'createdDate,desc'
        }
      }
      if (this.keyword) {
        data.keyword = this.keyword
      }
      this.$store.dispatch('getIntegralExchangeByUserId', data).then(res => {
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        if (next) {
          next(res.data)
        }
      }).catch(err => {
        this.$message.error(err || '获取用户积分兑换记录失败')
      })
    },
    getIntegralExchangeStatistical () {
      this.$store.dispatch('getIntegralExchangeStatistical', this.userLogin).then(res => {
        this.statisticalNum = res.data
      }).catch(err => {
        this.$message.error(err || '获取用户积分兑换记录统计失败')
      })
    }
  },
  created () {
    this.getIntegralExchangeStatistical()
  }
}
</script>
<style module lang="less">
  .exchange-record-header{
    :global{
      .wt-box{
          display: inline-flex;
          color: #EFC68C;
          margin: .5rem .3rem;
      }
    }
  }
  .exchange-record-number{
    font-size: 35px;
    margin:0 1rem 0 .1rem;
  }
</style>
